export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ10.c00d614a.mp3";